<template>
	<popup
		:opened="dataToShow"
		@close="changeToShow(false)"
	>
        <message-header :message-header="messageHeader" />

        <div class="sticky top-0 z-10">
            <!-- Save button -->
            <save-button 
                :saving="saving"
                @save="saveBeneficiaryTemplates"
                class="right-15 top-15"
            />
        </div>

        <!-- BEGIN Content modal beneficiary templates -->
        <div class="m-5 lg:m-15 2xl:m-20">
            <h3 class="mb-10">Gérer les modèles de pages de <br>{{beneficiaryToEdit.firstname}} <span class="uppercase">{{beneficiaryToEdit.lastname}}</span></h3>

            <!-- BEGIN TEMPLATES COMPETENCES PERSONNELLES -->
            <div class="grid grid-cols-12 gap-x-4 gap-y-6 mt-15 mb-10">
                <div class="col-span-full text-left text-indigo-600 text-base">
                    {{ "compétences personnelles".toUpperCase() }}
                </div>

                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).compcle"
                    name="compcle"
                    libelle="Compétences clés"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).compcle"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).compcle = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES)"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).compcle || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).compcle || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />

                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).informatique"
                    name="informatique"
                    libelle="Compétences informatiques"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).informatique"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).informatique = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE)"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).informatique || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).informatique || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />

                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).langue"
                    class="md:col-span-4"
                    name="langue"
                    libelle="Compétences linguistiques"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).langue"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).langue = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES)"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).langue || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).langue || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <!-- END TEMPLATES COMPETENCES PERSONNELLES -->
            </div>

            <!-- BEGIN TEMPLATES COMPETENCES SOCIO PROFESSIONNELLES -->
            <div class="grid grid-cols-12 gap-x-4 gap-y-6 mt-15 mb-10">
                <div class="col-span-full text-left text-indigo-600 text-base">
                    {{ "Compétences socio-professionnelles".toUpperCase() }}
                </div>

                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).aptitudes_perso"
                    name="aptitudes_perso"
                    libelle="Aptitudes Personnelles"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).aptitudes_perso"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).aptitudes_perso = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'aptitudes_perso')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).aptitudes_perso || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).aptitudes_perso || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).comportement_social"
                    name="comportement_social"
                    libelle="Comportement Social et Relationnel"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).comportement_social"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).comportement_social = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'comportement_social')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).comportement_social || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).comportement_social || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).aptitudes_pro"
                    name="aptitudes_pro"
                    libelle="Aptitudes au travail"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).aptitudes_pro"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).aptitudes_pro = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'aptitudes_pro')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).aptitudes_pro || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).aptitudes_pro || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).productivite"
                    name="productivite"
                    libelle="Productivité et Technicité"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).productivite"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).productivite = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'productivite')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).productivite || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).productivite || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).attitudes_pro"
                    name="attitudes_pro"
                    libelle="Attitudes au Travail"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).attitudes_pro"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).attitudes_pro = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'attitudes_pro')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).attitudes_pro || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).attitudes_pro || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).regles"
                    name="regles"
                    libelle="Rapport aux règles et aux contraintes"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).regles"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).regles = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'regles')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).regles || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).regles || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
            </div>
            <!-- END TEMPLATES COMPETENCES SOCIO PROFESSIONNELLES -->

            <!-- BEGIN TEMPLATES COMPETENCES PROFESSIONNELLES -->
            <div
                v-if="!isOF"
                class="grid grid-cols-12 gap-x-4 gap-y-6 mt-15 mb-10"
            >
                <div class="col-span-full text-left text-indigo-600 text-base">
                    {{ "Compétences professionnelles".toUpperCase() }}
                </div>
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).p1"
                    name="p1"
                    libelle="Poste 1"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).p1"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).p1 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == constants.PAGE_NEOPASS_FORM_POSTE_1)"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).p1 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).p1 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).p2"
                    name="p2"
                    libelle="Poste 2"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).p2"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).p2 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'p2')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).p2 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).p2 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).p3"
                    name="p3"
                    libelle="Poste 3"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).p3"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).p3 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'p3')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).p3 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).p3 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).p4"
                    name="p4"
                    libelle="Poste 4"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).p4"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).p4 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'p4')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).p4 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).p4 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).p5"
                    name="p5"
                    libelle="Poste 5"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).p5"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).p5 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'p5')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).p5 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).p5 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
            </div>
            <!-- END TEMPLATES COMPETENCES PROFESSIONNELLES -->

            <!-- BEGIN TEMPLATES COMPETENCES SCOLAIRES -->
            <div
                v-if="isOF"
                class="grid grid-cols-12 gap-x-4 gap-y-6 mt-15 mb-10"
            >
                <div class="col-span-full text-left text-indigo-600 text-base">
                    {{ "Compétences professionnelles".toUpperCase() }}
                </div>
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).f1"
                    name="f1"
                    libelle="Formation 1"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).f1"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).f1 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'f1')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).f1 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).f1 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).f2"
                    name="f2"
                    libelle="Formation 2"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).f2"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).f2 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'f2')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).f2 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).f2 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).f3"
                    name="f3"
                    libelle="Formation 3"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).f3"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).f3 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'f3')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).f3 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).f3 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).f4"
                    name="f4"
                    libelle="Formation 4"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).f4"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).f4 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'f4')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).f4 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).f4 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
                <input-select
                    v-if="((beneficiaryToEdit || {}).templates || {}).f5"
                    name="f5"
                    libelle="Formation 5"
                    class="md:col-span-4"
                    :value-is-object="true"
                    :value="((beneficiaryToEdit || {}).templates || {}).f5"
                    @input="
                        (newValue) => {
                            ((beneficiaryToEdit || {}).templates || {}).f5 = newValue;
                        }
                    "
                    :datas="templates.filter((t) => t.page == 'f5')"
                    :disabled="(((beneficiaryToEdit || {}).templates || {}).f5 || {}).inProgress"
                    :error="(((beneficiaryToEdit || {}).templates || {}).f5 || {}).inProgress"
                    msg-error="Une évaluation est en cours sur ce modèle"
                    :empty-case="false"
                />
            </div>
            <!-- END TEMPLATES COMPETENCES SCOLAIRES -->
        </div>
        <!-- END Content modal beneficiary templates -->
	</popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import MessageHeader from './../../../components/MessageHeader';
import Icon from './../../../components/Icon';

import InputSelect from './../../../components/Inputs/InputSelect';
import SaveButton from './../../../components/SaveButton.vue';

import Constants from './../../../constants';

export default {
  name: 'EditBenficiaryTemplatesPopup',

  props: {
    dataToShow: Boolean,
  },

  data() {
    return {
      constants: Constants,
    };
  },

  components: {
    Popup,
    MessageHeader,
    Icon,
    InputSelect,
    SaveButton,
  },

  computed: {
    ...mapGetters({
      saving: 'permissions/saving',
      messageHeader: 'permissions/messageHeader',
      beneficiaryToEdit: 'beneficiaries/beneficiaryToEdit',
      errors: 'permissions/errors',
      templates: 'beneficiaries/templates',
      structure: 'auth/structure'
    }),

    isOF(){
      return this.structure.type === Constants.TYPE_OF;
    }
  },

  methods: {
    ...mapActions({
      saveBeneficiaryTemplates: 'beneficiaries/saveBeneficiaryTemplates',
    }),

    ...mapMutations({
      SET_ERRORS: 'permissions/SET_ERRORS',
      SET_SAVING: 'permissions/SET_SAVING',
    }),

    changeToShow(val) {
      this.$emit('showChange', val);
      this.SET_ERRORS(null);
      this.SET_SAVING(false);
    },
  },
};
</script>
